// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1ForecastSummarySchema = z.object({
  task_count: z.number().int().describe("Number of tasks matching the filter"),
  estimated_total: z.object({
    hours: z.number().int(),
    minutes: z.number().int(),
    seconds: z.number().int(),
    formatted: z.coerce.string().min(1),
    total_hours: z.number(),
    total_seconds: z.number().int(),
    total_minutes: z.number().int(),
  }).describe("Total estimated duration"),
  logged_total: z.object({
    hours: z.number().int(),
    minutes: z.number().int(),
    seconds: z.number().int(),
    formatted: z.coerce.string().min(1),
    total_hours: z.number(),
    total_seconds: z.number().int(),
    total_minutes: z.number().int(),
  }).describe("Total logged duration"),
  planned_total: z.object({
    hours: z.number().int(),
    minutes: z.number().int(),
    seconds: z.number().int(),
    formatted: z.coerce.string().min(1),
    total_hours: z.number(),
    total_seconds: z.number().int(),
    total_minutes: z.number().int(),
  }).describe("Total planned duration"),
  due_dates: z.array(z.coerce.string()).describe("List of due dates"),
  user_id: z.number().int().describe("User ID (present for user summaries)").nullish(),
  project_id: z.number().int().describe("Project ID (present for project summaries)").nullish(),
});
